import InlineEditors from '../../controllers/inlineEditors';
import WebixContextMenu from '../../grid/webixContextMenu';

export default instance => {
  const onClick = e => {
    if (InlineEditors.isActive() && !e.target.closest('.gantt_row') && !e.target.closest('.gantt_grid_editor_placeholder') && !(e.target.closest('.webix_window') || !e.target.closest('.webixapp'))) {
      InlineEditors.onClick(true);
    }
  };

  const onMouseDown = e => {
    if (InlineEditors.isActive() && !e.target.closest('.gantt_row') && !e.target.closest('.gantt_grid_editor_placeholder') && !(e.target.closest('.webix_window') || !e.target.closest('.webixapp'))) {
      InlineEditors.onClick(true);
    }

    WebixContextMenu.onMouseDown(e);
  };

  document.addEventListener('click', onClick, false);
  document.addEventListener('mousedown', onMouseDown, false);

  instance.attachEvent('onDestroy', () => {
    document.removeEventListener('click', onClick);
    document.removeEventListener('mousedown', onMouseDown);
  });
};
